(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-api"] && !Shopify.designMode) return;
  try {
    if (!window.PrimeCartApi) {
  window.PrimeCartApi = {
    queue: Promise.resolve(),
    root() { return window.Shopify?.routes?.root || '/'; },
    enqueue(task) {
      const operation = this.queue.then(task, task);
      this.queue = operation.catch(() => {});
      return operation;
    },
    async request(endpoint, body = {}) {
      const response = await fetch(`${this.root()}cart/${endpoint}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'No se pudo actualizar el carrito');
      }
      return response.json();
    },
    async get() {
      const response = await fetch(`${this.root()}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('El carrito no está disponible');
      return response.json();
    },
    add(request) {
      return this.enqueue(async () => {
        const response = await fetch(`${this.root()}cart/add.js`, request);
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || error.message || 'No se pudo añadir el producto al carrito');
        }
        return this.removeLegacyPersonalization(await this.get());
      });
    },
    async removeLegacyPersonalization(cart, sections = [], sectionsUrl = '/cart') {
      const legacyAddons = cart.items.filter((item) => item.handle === 'personalizacion-de-jersey' || item.properties?._prime_role === 'personalization_addon');
      if (!legacyAddons.length) return cart;
      const legacyReferences = new Set(legacyAddons.map((item) => item.properties?._prime_bundle).filter(Boolean));
      const legacyJerseys = cart.items.filter((item) => legacyReferences.has(item.properties?._prime_bundle) && item.properties?._prime_role === 'jersey');
      const replacements = [];
      for (const item of legacyJerseys) {
        const reference = item.properties._prime_bundle;
        const alreadyMigrated = cart.items.some((candidate) => candidate.properties?._prime_migrated_bundle === reference);
        if (alreadyMigrated) continue;
        const response = await fetch(`${this.root()}products/${item.handle}.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('No se pudo actualizar un jersey personalizado del carrito');
        const product = await response.json();
        const currentOptions = (item.options_with_values?.map((option) => option.value) || item.variant_options || []).filter((value) => value !== 'Sin personalizar' && value !== 'Personalizado');
        const targetOptions = [...currentOptions, 'Personalizado'];
        const target = product.variants.find((variant) => variant.available && variant.options.every((value, index) => value === targetOptions[index]));
        if (!target) throw new Error('Vuelve a seleccionar la personalización de este jersey antes de pagar');
        const properties = {};
        Object.entries(item.properties || {}).forEach(([name, value]) => {
          if (!name.startsWith('_') && value) properties[name] = value;
        });
        properties._prime_role = 'jersey';
        properties._prime_migrated_bundle = reference;
        replacements.push({ id: target.id, quantity: item.quantity, properties });
      }
      if (replacements.length) {
        const response = await fetch(`${this.root()}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: replacements })
        });
        if (!response.ok) throw new Error('No se pudo actualizar el jersey personalizado del carrito');
      }
      const updates = {};
      [...legacyAddons, ...legacyJerseys].forEach((item) => { updates[item.key] = 0; });
      const body = { updates };
      if (sections.length) { body.sections = sections; body.sections_url = sectionsUrl; }
      return this.request('update', body);
    },
    async updateBundle(key, quantity, reference, sections = [], sectionsUrl = '/cart') {
      return this.enqueue(async () => {
        const updates = { [key]: Math.max(0, quantity) };
        if (reference) {
          const cart = await this.get();
          cart.items.filter((item) => item.key !== key && item.properties?._prime_bundle === reference).forEach((item) => { updates[item.key] = Math.max(0, quantity); });
        }
        const body = { updates };
        if (sections.length) { body.sections = sections; body.sections_url = sectionsUrl; }
        return this.request('update', body);
      });
    },
    async clear(sections = [], sectionsUrl = '/cart') {
      return this.enqueue(async () => {
        await this.request('clear');
        const body = { note: '' };
        if (sections.length) { body.sections = sections; body.sections_url = sectionsUrl; }
        return this.request('update', body);
      });
    },
    saveNote(note) {
      return this.enqueue(() => this.request('update', { note }));
    }
  };
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.dialog = this.querySelector('dialog');
      this.items = this.querySelector('[data-cart-items]');
      this.footer = this.querySelector('[data-cart-footer]');
      this.status = this.querySelector('[data-cart-status]');
      this.recommendationPool = this.querySelector('[data-cart-recommendation-pool]');
      this.queue = Promise.resolve();
      this.pendingQuantities = new Map();
      this.quantityTimers = new Map();
      this.quantityRequests = new Set();
      this.lastConfirmedCart = null;
      this.lastTrigger = null;
      this.querySelector('[data-cart-drawer-close]')?.addEventListener('click', () => this.close());
      this.dialog.addEventListener('click', (event) => { if (event.target === this.dialog) this.close(); });
      this.dialog.addEventListener('keydown', (event) => { if (event.key === 'Escape') { event.preventDefault(); this.close(); } });
      this.dialog.addEventListener('close', () => { document.body.classList.remove('drawer-open'); this.lastTrigger?.focus(); });
      document.addEventListener('click', (event) => this.handleClick(event));
      document.addEventListener('change', (event) => this.handleChange(event));
      document.addEventListener('prime:quantity-change', (event) => this.handleQuantityStep(event));
      document.addEventListener('submit', (event) => this.handleSubmit(event));
    }
    root() { return window.Shopify?.routes?.root || '/'; }
    money(cents) { return new Intl.NumberFormat(document.documentElement.lang, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100); }
    displayItemCount(cart) { return cart.items.reduce((sum, item) => sum + item.quantity, 0); }
    announce(message) { this.status.textContent = ''; requestAnimationFrame(() => { this.status.textContent = message; }); }
    async open(trigger, cart = null) { this.lastTrigger = trigger || document.activeElement; if (cart) this.render(await window.PrimeCartApi.removeLegacyPersonalization(cart)); else await this.refresh(); this.dialog.classList.remove('is-closing'); if (!this.dialog.open) this.dialog.showModal(); document.body.classList.add('drawer-open'); this.querySelector('[data-cart-drawer-close]')?.focus(); }
    close() {
      if (!this.dialog.open || this.dialog.classList.contains('is-closing')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { this.dialog.close(); return; }
      this.dialog.classList.add('is-closing');
      window.setTimeout(() => { this.dialog.classList.remove('is-closing'); this.dialog.close(); }, 320);
    }
    async handleClick(event) {
      const opener = event.target.closest('[data-cart-drawer-open]');
      if (opener) { event.preventDefault(); this.open(opener); return; }
      const quickAdd = event.target.closest('[data-cart-quick-add]');
      if (quickAdd && this.contains(quickAdd)) { event.preventDefault(); this.quickAdd(quickAdd); return; }
      const checkout = event.target.closest('.cart-drawer__footer a[href*="checkout"]');
      if (checkout && this.contains(checkout)) {
        event.preventDefault();
        const cart = await window.PrimeCartApi.removeLegacyPersonalization(await window.PrimeCartApi.get());
        this.render(cart);
        window.location.assign(checkout.href);
        return;
      }
      const remove = event.target.closest('[data-cart-remove]');
      if (remove) {
        const selector = this.querySelector(`quantity-selector[data-line="${CSS.escape(remove.dataset.cartRemove)}"]`);
        this.change(remove.dataset.cartRemove, 0, selector?.dataset.reference || '');
      }
      const clear = event.target.closest('[data-clear-cart]');
      if (clear) this.clearCart();
    }
    handleChange(event) {
      const selector = event.target.closest('cart-drawer quantity-selector[data-line]');
      if (selector) this.change(selector.dataset.line, Number(event.target.value), selector.dataset.reference);
    }
    handleQuantityStep(event) {
      const selector = event.target.closest('cart-drawer quantity-selector[data-line]');
      if (selector) this.change(selector.dataset.line, event.detail?.quantity, selector.dataset.reference, event.detail?.delta, event.detail?.previousQuantity);
    }
    handleSubmit(event) {
      const form = event.target.closest('form[data-ajax-cart]');
      if (!form) return;
      event.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      const wasDisabled = submit?.disabled;
      if (submit?.getAttribute('aria-busy') === 'true') return;
      const message = form.querySelector('[data-product-error]');
      if (message) message.textContent = '';
      let request;
      try {
        const personalization = form.querySelector('[data-personalization-toggle]:checked');
        request = personalization
          ? this.personalizationRequest(form, personalization)
          : { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) };
      } catch (error) {
        this.announce(error.message);
        if (message) message.textContent = error.message;
        return;
      }
      submit?.setAttribute('aria-busy', 'true');
      if (submit) submit.disabled = true;
      this.queue = this.queue.then(async () => {
        if (!window.PrimeCartApi) throw new Error('El carrito no está disponible. Recarga la página e intenta de nuevo.');
        const cart = await window.PrimeCartApi.add(request);
        await this.open(submit, cart);
        this.announce(this.dataset.addedMessage);
      }, async () => {
        if (!window.PrimeCartApi) throw new Error('El carrito no está disponible. Recarga la página e intenta de nuevo.');
        const cart = await window.PrimeCartApi.add(request);
        await this.open(submit, cart);
        this.announce(this.dataset.addedMessage);
      }).catch((error) => { this.announce(error.message); if (message) message.textContent = error.message; }).finally(() => { submit?.removeAttribute('aria-busy'); if (submit) submit.disabled = Boolean(wasDisabled); });
    }
    personalizationRequest(form, toggle) {
      const validationError = window.PrimePersonalization?.validateForm(form);
      if (validationError) throw new Error(validationError);
      const data = new FormData(form);
      data.delete('properties[_prime_bundle]');
      return { method: 'POST', headers: { Accept: 'application/json' }, body: data };
    }
    change(key, quantity, reference = '', delta = 0, previousQuantity = null) {
      const selector = this.querySelector(`quantity-selector[data-line="${CSS.escape(key)}"]`);
      const input = selector?.querySelector('input');
      const pending = this.pendingQuantities.get(key);
      const eventBase = Number.isFinite(Number(previousQuantity)) ? Number(previousQuantity) : Number(input?.value) - Number(delta || 0);
      const baseQuantity = pending?.quantity ?? Math.max(0, eventBase);
      const nextQuantity = Math.max(0, Math.floor(delta ? baseQuantity + Number(delta) : Number.isFinite(quantity) ? quantity : 0));
      this.pendingQuantities.set(key, { quantity: nextQuantity, reference: reference || pending?.reference || '' });
      this.renderOptimistic();
      window.clearTimeout(this.quantityTimers.get(key));
      this.quantityTimers.set(key, window.setTimeout(() => this.commitQuantity(key), 90));
    }
    optimisticCart() {
      if (!this.lastConfirmedCart) return null;
      const cart = structuredClone(this.lastConfirmedCart);
      const desiredByReference = new Map();
      this.pendingQuantities.forEach((pending, key) => {
        desiredByReference.set(pending.reference || key, pending.quantity);
      });
      cart.items.forEach((item) => {
        const reference = item.properties?._prime_bundle || item.key;
        if (!desiredByReference.has(reference)) return;
        const quantity = desiredByReference.get(reference);
        const unitPrice = item.quantity ? item.final_line_price / item.quantity : item.final_price;
        item.quantity = quantity;
        item.final_line_price = Math.round(unitPrice * quantity);
      });
      cart.total_price = cart.items.reduce((sum, item) => sum + item.final_line_price, 0);
      return cart;
    }
    renderOptimistic() {
      const cart = this.optimisticCart();
      if (!cart) return;
      cart.items.forEach((item) => {
        const line = this.querySelector(`[data-cart-line="${CSS.escape(item.key)}"]`);
        if (!line) return;
        const input = line.querySelector('quantity-selector input');
        if (input) input.value = item.quantity;
        const price = line.querySelector('[data-cart-line-price]');
        if (price) price.textContent = this.money(item.final_line_price);
      });
      const subtotal = this.querySelector('[data-cart-subtotal]');
      if (subtotal) subtotal.textContent = this.money(cart.total_price);
      const displayCount = this.displayItemCount(cart);
      document.querySelectorAll('.site-header__cart span').forEach((count) => {
        count.textContent = displayCount;
        const link = count.closest('.site-header__cart');
        if (link?.dataset.cartLabel) link.setAttribute('aria-label', link.dataset.cartLabel.replace('__COUNT__', displayCount));
      });
      this.updateProgress(cart);
    }
    async commitQuantity(key) {
      if (this.quantityRequests.has(key)) return;
      const pending = this.pendingQuantities.get(key);
      if (!pending || !window.PrimeCartApi) return;
      this.quantityRequests.add(key);
      this.announce(this.dataset.updatingMessage);
      try {
        const cart = await window.PrimeCartApi.updateBundle(key, pending.quantity, pending.reference);
        this.lastConfirmedCart = cart;
        if (this.pendingQuantities.get(key) === pending) {
          this.pendingQuantities.delete(key);
          this.render(cart);
        } else this.renderOptimistic();
      } catch (error) {
        this.pendingQuantities.delete(key);
        if (this.lastConfirmedCart) this.render(this.lastConfirmedCart);
        else await this.refresh();
        this.announce(error.message);
      } finally {
        this.quantityRequests.delete(key);
        if (this.pendingQuantities.has(key)) this.commitQuantity(key);
      }
    }
    async clearCart() {
      if (!window.PrimeCartApi) return;
      this.announce(this.dataset.updatingMessage);
      try { this.render(await window.PrimeCartApi.clear()); } catch (error) { this.announce(error.message); }
    }
    async refresh() {
      this.render(await window.PrimeCartApi.removeLegacyPersonalization(await window.PrimeCartApi.get()));
    }
    pickRecommendations(limit = 2) {
      const cards = [...(this.recommendationPool?.querySelectorAll('[data-cart-recommendation]') || [])];
      if (!cards.length) return [];
      let previousHandles = [];
      try { previousHandles = JSON.parse(sessionStorage.getItem('prime-cart-recommendations') || '[]'); } catch (_) { previousHandles = []; }
      const shuffle = (items) => items
        .map((item) => ({ item, order: window.crypto?.getRandomValues ? window.crypto.getRandomValues(new Uint32Array(1))[0] : Math.random() }))
        .sort((left, right) => left.order - right.order)
        .map(({ item }) => item);
      const previous = new Set(previousHandles);
      const fresh = shuffle(cards.filter((card) => !previous.has(card.dataset.productHandle)));
      const selected = fresh.slice(0, limit);
      if (selected.length < limit) {
        selected.push(...shuffle(cards.filter((card) => !selected.includes(card))).slice(0, limit - selected.length));
      }
      try { sessionStorage.setItem('prime-cart-recommendations', JSON.stringify(selected.map((card) => card.dataset.productHandle))); } catch (_) {}
      return selected.map((card) => {
        const clone = card.cloneNode(true);
        const image = clone.querySelector('[data-recommendation-image-src]');
        if (image) image.src = image.dataset.recommendationImageSrc;
        clone.querySelector('.cart-drawer__recommendation-media')?.removeAttribute('tabindex');
        return clone;
      });
    }
    renderEmpty() {
      const empty = document.createElement('div'); empty.className = 'cart-drawer__empty';
      const intro = document.createElement('div'); intro.className = 'cart-drawer__empty-intro';
      const message = document.createElement('p'); message.textContent = this.dataset.emptyMessage;
      const heading = document.createElement('h3'); heading.textContent = this.dataset.recommendationsTitle;
      const subtitle = document.createElement('p'); subtitle.textContent = this.dataset.recommendationsSubtitle;
      intro.append(message, heading, subtitle); empty.append(intro);
      const cards = this.pickRecommendations();
      if (cards.length) {
        const recommendations = document.createElement('div'); recommendations.className = 'cart-drawer__recommendations';
        recommendations.append(...cards); empty.append(recommendations);
      }
      const link = document.createElement('a'); link.className = 'button'; link.href = `${this.root()}collections/catalogo`; link.textContent = this.dataset.viewAllMessage;
      empty.append(link); this.items.append(empty); this.footer.hidden = true;
    }
    async quickAdd(button) {
      if (!window.PrimeCartApi || button.getAttribute('aria-busy') === 'true') return;
      const card = button.closest('[data-cart-recommendation]');
      const variantId = Number(card?.querySelector('[data-quick-add-variant]')?.value);
      if (!variantId) { this.announce('Selecciona una variante disponible.'); return; }
      const originalText = button.textContent;
      button.setAttribute('aria-busy', 'true'); button.disabled = true; button.textContent = this.dataset.quickAddingMessage;
      const body = new FormData(); body.set('id', String(variantId)); body.set('quantity', '1'); body.set('properties[_prime_role]', 'jersey');
      try {
        const cart = await window.PrimeCartApi.add({ method: 'POST', headers: { Accept: 'application/json' }, body });
        this.render(cart); this.announce(this.dataset.addedMessage);
      } catch (error) {
        this.announce(error.message); button.removeAttribute('aria-busy'); button.disabled = false; button.textContent = originalText;
      }
    }
    render(cart) {
      this.lastConfirmedCart = cart;
      this.items.replaceChildren();
      if (!cart.items.length) {
        this.renderEmpty();
      } else {
        cart.items.forEach((item) => this.items.append(this.createItem(item)));
        this.footer.hidden = false;
        this.querySelector('[data-cart-subtotal]').textContent = this.money(cart.total_price);
      }
      document.querySelectorAll('.site-header__cart span').forEach((count) => {
        const displayCount = this.displayItemCount(cart);
        const previousCount = Number(count.textContent) || 0;
        count.textContent = displayCount;
        const link = count.closest('.site-header__cart');
        if (link?.dataset.cartLabel) link.setAttribute('aria-label', link.dataset.cartLabel.replace('__COUNT__', displayCount));
        if (displayCount > previousCount) {
          count.classList.remove('is-bumping');
          requestAnimationFrame(() => count.classList.add('is-bumping'));
          count.addEventListener('animationend', () => count.classList.remove('is-bumping'), { once: true });
        }
      });
      this.updateProgress(cart);
      this.announce(this.dataset.updatedMessage);
    }
    updateProgress(cart) {
      const progress = this.querySelector('[data-shipping-progress]');
      if (!progress) return;
      const threshold = Number(progress.dataset.threshold) || 3;
      const eligible = cart.items.filter((item) => item.properties?._prime_role === 'jersey').reduce((sum, item) => sum + item.quantity, 0);
      const remaining = Math.max(0, threshold - eligible);
      progress.querySelector('[data-shipping-progress-message]').textContent = remaining === 0 ? this.dataset.progressAchieved : this.dataset.progressRemaining.replace('__COUNT__', remaining);
      const bar = progress.querySelector('[data-shipping-progress-bar]');
      bar?.style.setProperty('--shipping-progress', `${Math.min(100, eligible / threshold * 100)}%`);
      const meter = progress.querySelector('[role="progressbar"]');
      meter?.setAttribute('aria-valuenow', String(Math.min(eligible, threshold)));
    }
    createItem(item) {
      const article = document.createElement('article'); article.className = 'cart-drawer__item'; article.dataset.cartLine = item.key; article.dataset.quantity = String(item.quantity); article.dataset.linePrice = String(item.final_line_price);
      if (item.image) { const mediaLink = document.createElement('a'); mediaLink.href = item.url; const image = document.createElement('img'); image.src = item.image; image.width = 76; image.height = 96; image.alt = item.featured_image?.alt || item.product_title; mediaLink.append(image); article.append(mediaLink); }
      const details = document.createElement('div'); const titleLink = document.createElement('a'); titleLink.href = item.url; const title = document.createElement('strong'); title.textContent = item.product_title; titleLink.append(title); details.append(titleLink);
      const visibleOptions = item.options_with_values?.length
        ? item.options_with_values.filter((option) => option.name !== 'Personalización').map((option) => option.value)
        : (item.variant_options || []).filter((value) => value !== 'Personalizado' && value !== 'Sin personalizar');
      if (visibleOptions.length) { const variant = document.createElement('p'); variant.textContent = visibleOptions.join(' / '); details.append(variant); }
      Object.entries(item.properties || {}).filter(([name, value]) => !name.startsWith('_') && value).forEach(([name, value]) => { const property = document.createElement('p'); property.textContent = `${name}: ${value}`; details.append(property); });
      const price = document.createElement('p'); price.dataset.cartLinePrice = ''; price.textContent = this.money(item.final_line_price); details.append(price);
      const remove = document.createElement('button'); remove.type = 'button'; remove.dataset.cartRemove = item.key; remove.textContent = this.dataset.removeMessage; details.append(remove);
      article.append(details);
      const quantity = document.createElement('quantity-selector'); quantity.className = 'quantity-selector'; quantity.dataset.line = item.key;
      if (item.properties?._prime_bundle) quantity.dataset.reference = item.properties._prime_bundle;
      if (item.properties?._prime_role) quantity.dataset.role = item.properties._prime_role;
      const minus = document.createElement('button'); minus.type = 'button'; minus.name = 'minus'; minus.textContent = '−'; minus.setAttribute('aria-label', this.dataset.decreaseMessage);
      const input = document.createElement('input'); input.type = 'number'; input.value = item.quantity; input.min = '0'; input.inputMode = 'numeric'; input.setAttribute('aria-label', this.dataset.quantityMessage);
      const plus = document.createElement('button'); plus.type = 'button'; plus.name = 'plus'; plus.textContent = '+'; plus.setAttribute('aria-label', this.dataset.increaseMessage);
      quantity.append(minus, input, plus); article.append(quantity); return article;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["motion-system"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.PrimeMotion) {
    window.PrimeMotion.initialize(document);
    return;
  }

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observed = new WeakSet();
  const parallaxItems = new Set();
  const visibleParallaxItems = new Set();
  let frameRequested = false;

  const revealObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 })
    : null;

  const updateParallax = () => {
    frameRequested = false;
    if (reducedMotion.matches || window.innerWidth < 990) {
      parallaxItems.forEach((item) => item.style.removeProperty('--parallax-offset'));
      return;
    }
    const items = 'IntersectionObserver' in window ? visibleParallaxItems : parallaxItems;
    items.forEach((item) => {
      if (!item.isConnected) {
        parallaxItems.delete(item);
        return;
      }
      const rect = item.getBoundingClientRect();
      const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
      const strength = Number(item.dataset.parallaxStrength || 18);
      const offset = Math.max(-strength, Math.min(strength, (progress - 0.5) * strength * 2));
      item.style.setProperty('--parallax-offset', `${offset.toFixed(2)}px`);
    });
  };

  const requestParallax = () => {
    if (frameRequested) return;
    frameRequested = true;
    requestAnimationFrame(updateParallax);
  };

  const parallaxObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) visibleParallaxItems.add(entry.target);
          else visibleParallaxItems.delete(entry.target);
        });
        requestParallax();
      }, { rootMargin: '12% 0px' })
    : null;

  const initialize = (scope = document) => {
    const reveals = [];
    if (scope.matches?.('[data-reveal]')) reveals.push(scope);
    reveals.push(...(scope.querySelectorAll?.('[data-reveal]') || []));
    reveals.forEach((item) => {
      if (observed.has(item)) return;
      observed.add(item);
      if (!document.body.classList.contains('motion-enabled') || reducedMotion.matches || !revealObserver) {
        item.classList.add('is-revealed');
        return;
      }
      revealObserver.observe(item);
    });

    const parallax = [];
    if (scope.matches?.('[data-parallax]')) parallax.push(scope);
    parallax.push(...(scope.querySelectorAll?.('[data-parallax]') || []));
    parallax.forEach((item) => {
      if (parallaxItems.has(item)) return;
      parallaxItems.add(item);
      parallaxObserver?.observe(item);
    });
    document.documentElement.classList.add('motion-ready');
    requestParallax();
  };

  window.PrimeMotion = { initialize };
  initialize(document);
  window.addEventListener('scroll', requestParallax, { passive: true });
  window.addEventListener('resize', requestParallax, { passive: true });
  reducedMotion.addEventListener?.('change', requestParallax);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:reorder', () => initialize(document));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["native-facets"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('native-facet-controller')) {
  customElements.define('native-facet-controller', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.form = this.querySelector('[data-native-facet-form]');
      this.drawer = this.querySelector('[data-native-filter-drawer]');
      this.openButton = this.querySelector('[data-native-filter-open]');
      this.status = this.querySelector('[data-native-facet-status]');
      this.requestController = null;
      this.form?.addEventListener('submit', (event) => { event.preventDefault(); this.load(this.formUrl(event.submitter)); });
      this.querySelector('[data-native-sort]')?.addEventListener('change', () => this.load(this.formUrl()));
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-native-facet-link]');
        if (link) { event.preventDefault(); this.close(false); this.load(new URL(link.href)); return; }
        if (event.target.closest('[data-native-filter-open]')) { event.preventDefault(); this.open(); return; }
        if (event.target.closest('[data-native-filter-close]')) { event.preventDefault(); this.close(); }
      });
      this.handleKeydown = (event) => this.onKeydown(event);
      document.addEventListener('keydown', this.handleKeydown);
    }
    disconnectedCallback() {
      this.requestController?.abort();
      document.removeEventListener('keydown', this.handleKeydown);
    }
    formUrl(submitter) {
      const url = new URL(this.form.action, window.location.origin);
      const data = new FormData(this.form);
      if (submitter?.name) data.set(submitter.name, submitter.value);
      data.delete('page');
      for (const [name, value] of data.entries()) if (String(value).trim()) url.searchParams.append(name, value);
      return url;
    }
    open() {
      if (!this.drawer) return;
      this.drawer.hidden = false;
      this.drawer.classList.add('is-open');
      requestAnimationFrame(() => {
        this.drawer.classList.add('is-visible');
        this.openButton?.setAttribute('aria-expanded', 'true');
        document.body.classList.add('filter-open');
        this.drawer.querySelector('.native-facets__header button')?.focus();
      });
    }
    close(restoreFocus = true) {
      if (!this.drawer?.classList.contains('is-open')) return;
      this.drawer.classList.remove('is-visible');
      this.openButton?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('filter-open');
      window.setTimeout(() => {
        if (this.drawer?.classList.contains('is-visible')) return;
        this.drawer?.classList.remove('is-open');
        if (this.drawer) this.drawer.hidden = true;
        if (restoreFocus) this.openButton?.focus();
      }, 320);
    }
    onKeydown(event) {
      if (!this.drawer?.classList.contains('is-open')) return;
      if (event.key === 'Escape') { event.preventDefault(); this.close(); return; }
      if (event.key !== 'Tab') return;
      const focusable = [...this.drawer.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), summary')].filter((element) => element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
    async load(url, pushState = true) {
      const section = this.closest('[data-faceted-section]');
      const sectionId = this.dataset.sectionId;
      if (!section || !sectionId) { window.location.assign(url); return; }
      this.requestController?.abort();
      this.requestController = new AbortController();
      section.classList.add('is-loading');
      if (this.status) this.status.textContent = 'Actualizando productos';
      const requestUrl = new URL(url);
      requestUrl.searchParams.set('section_id', sectionId);
      try {
        const response = await fetch(requestUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, signal: this.requestController.signal });
        if (!response.ok) throw new Error('No se pudieron aplicar los filtros');
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const replacement = parsed.querySelector('[data-faceted-section]');
        if (!replacement) throw new Error('La sección no está disponible');
        document.body.classList.remove('filter-open');
        if (pushState) window.history.pushState({}, '', url);
        section.replaceWith(replacement);
        window.PrimeMotion?.initialize(replacement);
        replacement.querySelector('[data-native-facet-status]')?.replaceChildren(document.createTextNode('Productos actualizados'));
      } catch (error) {
        if (error.name === 'AbortError') return;
        window.location.assign(url);
      }
    }
  });
}
if (!window.PrimeNativeFacetsPopstate) {
  window.PrimeNativeFacetsPopstate = true;
  window.addEventListener('popstate', () => document.querySelector('native-facet-controller')?.load(new URL(window.location.href), false));
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["personalization-rules"] && !Shopify.designMode) return;
  try {
    window.PrimePersonalization = window.PrimePersonalization || {
  blockedTerms: ['puto', 'puta', 'verga', 'pendejo', 'pendeja', 'chinga', 'mierda', 'cabron', 'idiota', 'marica', 'culero', 'pinche'],
  namePattern: /^\p{L}+(?: \p{L}+)*$/u,
  numberPattern: /^(0|[1-9]\d?)$/,
  normalize(value) {
    return String(value || '').normalize('NFD').replace(/\p{M}/gu, '').toLowerCase();
  },
  containsBlockedTerm(value) {
    const normalized = this.normalize(value);
    return this.blockedTerms.some((term) => normalized.includes(term));
  },
  sanitizeName(input) {
    const cleaned = String(input.value || '')
      .normalize('NFC')
      .replace(/\s{2,}/g, ' ');
    if (cleaned !== input.value) input.value = cleaned;
  },
  sanitizeNumber(input) {
    const normalized = String(input.value || '').trim();
    if (normalized !== input.value) input.value = normalized;
  },
  validateForm(form) {
    const toggle = form.querySelector('[data-personalization-toggle]:checked');
    if (!toggle) return null;

    const nameInput = form.querySelector('[data-personalization-name]');
    const numberInput = form.querySelector('[data-personalization-number]');
    const nameValue = String(nameInput?.value || '').trim().replace(/\s{2,}/g, ' ');
    const numberValue = String(numberInput?.value || '').trim();

    if (!nameValue) return form.dataset.personalizationNameRequired || 'Escribe el nombre.';
    if (nameValue.length > 12) return form.dataset.personalizationNameInvalid || 'El nombre admite hasta 12 letras.';
    if (!this.namePattern.test(nameValue)) return form.dataset.personalizationNameInvalid || 'Nombre inválido.';
    if (this.containsBlockedTerm(nameValue)) return form.dataset.personalizationNameBlocked || 'Nombre no permitido.';

    if (!numberValue) return form.dataset.personalizationNumberRequired || 'Escribe el número.';
    if (!this.numberPattern.test(numberValue) || Number(numberValue) > 99) {
      return form.dataset.personalizationNumberInvalid || 'Número inválido.';
    }

    return null;
  }
};
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quantity-selector')) {
  customElements.define('quantity-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const input = this.querySelector('input');
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button) return;
        const previousQuantity = Number(input.value);
        const delta = button.name === 'plus' ? 1 : -1;
        if (delta > 0) input.stepUp();
        else input.stepDown();
        this.dispatchEvent(new CustomEvent('prime:quantity-change', { bubbles: true, detail: { delta, previousQuantity, quantity: Number(input.value) } }));
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
